export type BusinessDetails = {
  id: string;
  entityName?: string;
  name?: string;
  __children: BusinessDetails[];
  parentOrgUnitId?: string;
  childIds: string[];
  canAccess?: boolean;
  identifier?: string;
  level: string;
  metadata?: object;
};

export type BuzzDataType = {
  id: string;
  name?: string;
  canAccess?: boolean;
  identifier?: string;
  parentOrgUnitId?: string;
  level: string;
};

export enum BusinessLevels {
  BRANCH = 'BRANCH',
  PAN = 'PAN',
  GSTIN = 'GSTIN',
}

export type ReportFilter = {
  invoiceStartDate: string;
  invoiceEndDate: string;
  gstinOrgId?: string[];
  branchOrgId?: string[];
  panOrgId?: string[];
};

export type IRNSummaryDetails = {
  totalIrnCancelled: number;
  totalIrnFailed: number;
  totalIrnGenerated: number;
  totalNoOfInvoices: number;
  totalPendingIrnGeneration: number;
};

export type MISReportsMetadata = {
  Count: number;
  TaxableAmount: number;
};

export type MISReportsDataTypes = {
  Generated: MISReportsMetadata;
  Failed: MISReportsMetadata;
  Cancelled: MISReportsMetadata;
  NotGenerated: MISReportsMetadata;
  Total: MISReportsMetadata;
};

export type ReportsDataDayWise = {
  Date: string;
  ReportsData: MISReportsDataTypes;
};

export type IRNReportMetadataResponse = {
  CanAccess: boolean;
  Id: string;
  Name: string;
  Level: BusinessLevels;
  ParentOrgUnitId: string;
  ReportsDataPerDay: ReportsDataDayWise[];
};

export type MISReport = {
  CanAccess: boolean;
  Id: string;
  Name: string;
  Level: BusinessLevels;
  ParentOrgUnitId: string;
  ReportsData: MISReportsDataTypes;
};

export type MISReportSummaryResponse = {
  MisReport: MISReport[];
};

export type IRNComplianceSummary = {
  branchOrgName?: string;
  gstinOrgName: string;
  gstin: string;
  orgId?: string;
  irnSummaryDetails: IRNSummaryDetails;
};

export type LoginResponse = {
  status: boolean;
  message?: string;
};

export type Filter = {
  invoiceStartDate: string;
  invoiceEndDate: string;
  orgId?: string;
};

export enum SupplyType {
  B2B = 'B2B',
  B2C = 'B2C',
  SEZWP = 'SEZWP',
  SEZWOP = 'SEZWOP',
  EXPWP = 'EXPWP',
  EXPWOP = 'EXPWOP',
  DEXP = 'DEXP',
}

export enum InvoiceType {
  INV = 'INV',
  CRN = 'CRN',
  DBN = 'DBN',
  CDN = 'CDN',
}

export enum InvoiceStatus {
  NOT_GENERATED = 'NOT_GENERATED',
  GENERATED = 'GENERATED',
  GENERATION_FAILED = 'GENERATION_FAILED',
  CANCELLED = 'CANCELLED',
}

export enum ErrorSource {
  GOVT = 'GOVT',
  CLEARTAX = 'CLEARTAX',
}

export enum Range {
  TODAY = 'TODAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}

export type ErrorDetail = {
  ErrorCode: string;
  ErrorMessage: string;
  ErrorSource: ErrorSource;
  Path: string;
};

export type EinvoiceSummaryDTO = {
  invoiceId: string;
  invoiceDate: string;
  invoiceNumber: string;
  buyerGstin: string;
  buyerName: string;
  totalInvoiceValue: number;
  irnGenerationDate: string;
  supplyType: SupplyType;
  invoiceType: InvoiceType;
  ewbNo: number | null;
  irn: string;
  taxableValue: number;
  totalTax: number;
  cancellationReasonCode: string | null;
  invoiceStatus: InvoiceStatus;
  errorDetails: null | ErrorDetail;
  cancellationFailureError: null | ErrorDetail;
};

export type PageMetaInfo = {
  currentPage: number;
  totalItems?: number;
  totalPages?: number;
};

export type EinvoicePage = {
  pageMetaInfo: PageMetaInfo;
  einvoiceSummaryDtos: EinvoiceSummaryDTO[];
};

export enum ToastNature {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
}

export enum ErrorToastText {
  SUMMARY = 'Failed to get Summary data',
  METADATA = 'Failed to get metadata',
  COMPLIANCE = 'Failed to get Compliance data',
  INVOICE = 'Failed to get invoices data',
  HIERARCHY = 'Failed to get business hierarchy data',
  DOWNLOAD_PDF = 'Failed to download pdf',
  SHARE_INV_DETAILS = 'Failed to share invoice details',
  EMAIL = 'Failed to get email',
}
